import React, { useState } from "react";
import { useGet } from "../../common/hooks";
import { Division, Game } from "../../common/interfaces";
import { Divider } from "antd";
import { allKnownDivisions, dtNow, getDivisionName } from "../../common/utils";
import { CompactTable } from "../../common/components/CompactTable";
import { DivisionSelect } from "../../common/components/DivisionSelect";
import { useParams } from "react-router-dom";
import { goalieGameColumns } from "../goalieGameColumns";
import _ from "lodash";

export function GoalieGameHistory() {
  const { division: divisionParam } = useParams<{ division?: string }>();
  const initialDivision = allKnownDivisions.find(d => getDivisionName(d).toLowerCase() === divisionParam?.toLowerCase());
  const [division, setDivision] = useState<Division | undefined>(initialDivision);
  const games = useGet<Game[]>(division !== undefined ? "/api/games" : undefined);

  const pastGames = _.orderBy(
    (games.data || []).filter(g => g.date <= dtNow() && (!division || g.division === division)),
    g => g.date,
    "desc"
  );

  return (
    <>
      <Divider>Goalie Game History</Divider>
      <DivisionSelect
        value={division}
        onChange={setDivision}
        onClear={() => setDivision(undefined)}
      />
      <CompactTable
        data={pastGames}
        columns={goalieGameColumns}
        loading={games.isLoading}
      />
    </>
  );
}
